import { createTheme } from '@mui/material';
import palette from './palette';

const themeOptions = {
  typography: {
    fontFamily: "Roboto, sans-serif",
  },
  palette,
};

const theme = createTheme(themeOptions);
export default theme;
